import * as types from "./types";
import { toast } from "react-toastify";

import API from "../utils/API";
import { isLocalAPI } from "../utils/utils";

import store from "../store";

export const tryFetchPointsOfAttention = () => (dispatch) => {
    const {
        auth: { accessToken },
        pointsOfAttention: { datas, loaded },
    } = store.getState();

    if (loaded) {
        return Promise.resolve(datas);
    }

    dispatch({ type: types.POINTS_OF_ATTENTION_FETCH_REQUESTED });
    return API.request({
        path: isLocalAPI ? "/point_of_attentions" : "/dap-admin/api/v1/customers/patients/point-of-attentions",
        queryParams: {
            pagination: false,
        },
        token: accessToken,
    })
        .then((response) => {
            dispatch({ type: types.POINTS_OF_ATTENTION_FETCH_SUCCESS, data: response["hydra:member"] });
            return response["hydra:member"];
        })
        .catch((error) => {
            dispatch({ type: types.POINTS_OF_ATTENTION_FETCH_FAILURE, data: error });
            throw error;
        });
};

export const tryCreatePointsOfAttention = (data) => (dispatch) => {
    const {
        auth: { accessToken },
    } = store.getState();

    dispatch({ type: types.POINTS_OF_ATTENTION_CREATE_REQUESTED });
    return API.request({
        path: isLocalAPI ? "/point_of_attentions" : "/dap-admin/api/v1/customers/patients/point-of-attentions",
        method: "POST",
        token: accessToken,
        data,
    })
        .then((response) => {
            toast.success("Le point de vigilance a été créé avec succès.");
            dispatch({ type: types.POINTS_OF_ATTENTION_CREATE_SUCCESS, data: response });
            return response;
        })
        .catch((error) => {
            toast.error("Une erreur s'est produite lors de la création du point de vigilance.");
            dispatch({ type: types.POINTS_OF_ATTENTION_CREATE_FAILURE, data: error });
            throw error;
        });
};

export const tryEditPointsOfAttention = (id, data) => (dispatch) => {
    const {
        auth: { accessToken },
    } = store.getState();

    dispatch({ type: types.POINTS_OF_ATTENTION_EDIT_REQUESTED });
    return API.request({
        path: isLocalAPI ? "/point_of_attentions/{id}" : "/dap-admin/api/v1/customers/patients/point-of-attentions/{id}",
        uriParams: {
            id,
        },
        method: "PUT",
        token: accessToken,
        data,
    })
        .then((response) => {
            toast.success("Le point de vigilance a été modifié avec succès.");
            dispatch({ type: types.POINTS_OF_ATTENTION_EDIT_SUCCESS, data: response });
            return response;
        })
        .catch((error) => {
            toast.error("Une erreur s'est produite lors de la modification du point de vigilance.");
            dispatch({ type: types.POINTS_OF_ATTENTION_EDIT_FAILURE, data: error });
            throw error;
        });
};

export const tryDeletePointsOfAttention = (id) => (dispatch) => {
    const {
        auth: { accessToken },
    } = store.getState();

    dispatch({ type: types.POINTS_OF_ATTENTION_DELETE_REQUESTED });
    return API.request({
        path: isLocalAPI ? "/point_of_attentions/{id}" : "/dap-admin/api/v1/customers/patients/point-of-attentions/{id}",
        uriParams: {
            id,
        },
        method: "DELETE",
        token: accessToken,
    })
        .then((response) => {
            toast.success("Le point de vigilance a été supprimé avec succès.");
            dispatch({ type: types.POINTS_OF_ATTENTION_DELETE_SUCCESS, data: id });
            return response;
        })
        .catch((error) => {
            toast.error("Une erreur s'est produite lors de la suppression du point de vigilance.");
            dispatch({ type: types.POINTS_OF_ATTENTION_DELETE_FAILURE, data: error });
            throw error;
        });
};
